import { onConsentChange, openConsentBanner, whenCmpSettled } from '../../../../../assets/private/js/cookieConsent';

const VISIBLE_CLASS = 'is-visible';
const CTA_SELECTOR = '.js-video-consent-placeholder__cta';
const OBSERVED_SELECTOR = '[data-video-consent="observe"]';

function isBlocked(placeholder) {
  const wrapper = placeholder.parentElement;
  const iframe = wrapper ? wrapper.querySelector('iframe') : null;

  if (!iframe) return true;

  const src = iframe.getAttribute('src');

  return !src || !src.trim() || src === 'about:blank';
}

function syncPlaceholder(placeholder) {
  placeholder.classList.toggle(VISIBLE_CLASS, isBlocked(placeholder));
}

function syncAll() {
  document.querySelectorAll(OBSERVED_SELECTOR).forEach(syncPlaceholder);
}

class VideoConsentPlaceholder {
  constructor(element) {
    this.element = element;
    this.wrapper = element.parentElement;

    syncPlaceholder(this.element);
    this.observeWrapper();
  }

  observeWrapper() {
    if (!this.wrapper) return;

    const observer = new MutationObserver(() => syncPlaceholder(this.element));

    observer.observe(this.wrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src'],
    });
  }
}

document.addEventListener('click', event => {
  const cta = event.target.closest ? event.target.closest(CTA_SELECTOR) : null;

  if (!cta) return;

  event.preventDefault();

  if (!openConsentBanner()) {
    window.location.reload();
  }
});

onConsentChange(syncAll);
whenCmpSettled().then(syncAll);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(OBSERVED_SELECTOR).forEach(element => {
    new VideoConsentPlaceholder(element);
  });
});
